module.exports = __webpack_public_path__ + "img/4_6.0e9abe88.png";